import React from 'react';
import { PopUpNotification } from 'extracted-chat-components';

import {
  ButtonColor,
  ButtonShape,
  ButtonSize,
} from 'constants/enums';

import ChatEndFeedbackPopup from './ChatEndFeedbackPopup';

const DueToAppointment = ({
  isNotificationPopUp,
  popUpNotificationData,
  deleteCurrentChat,
  showPopUpNotification,
  setIsSwitchedConversations,
  isReadingFeedbackEnabled,
  onLeaveFeedbackNow,
  onLeaveFeedbackLater,
}) => {
  const closePopup = () => {
    deleteCurrentChat();
    showPopUpNotification(false);
    setIsSwitchedConversations(false);
  };

  if (isReadingFeedbackEnabled) {
    return (
      <ChatEndFeedbackPopup
        isOpen={isNotificationPopUp}
        title={popUpNotificationData.title}
        description={popUpNotificationData.description}
        isFixedButtonSize
        primaryBtnText="Leave Reading Feedback Now"
        secondaryBtnText="Leave Feedback Later"
        onAccept={() => { closePopup(); onLeaveFeedbackNow(); }}
        onCancel={() => { closePopup(); onLeaveFeedbackLater(); }}
      />
    );
  }

  const acceptButton = {
    text: 'Okay',
    color: ButtonColor.WARNING,
    size: ButtonSize.XS,
    shape: ButtonShape.ROUNDED,
    handler: closePopup,
  };

  return (
    <PopUpNotification
      isOpen={isNotificationPopUp}
      title={popUpNotificationData.title}
      isTextNewLine={popUpNotificationData.isTextNewLine}
      acceptButton={acceptButton}
      rejectButton={null}
      isBigWidth={false}
    />
  );
};

export default DueToAppointment;
